module.exports = __webpack_public_path__ + "static/media/powerdocs_icons_mobile__V2_transparent.8daf9a70.gif";